import { addDays, isoDate } from './format.js';

/** Montag der Woche (lokal), YYYY-MM-DD. */
export function montag(iso) {
  const d = new Date(`${iso}T12:00:00`);
  return addDays(iso, -((d.getDay() + 6) % 7));
}

const tagVon = (l) => String(l.datum ?? '').slice(0, 10);

/**
 * Kopierplan für Zeiteinträge.
 * - modus 'tag': alle Einträge auf das Zieldatum
 * - modus 'woche': jeder Eintrag auf denselben Wochentag der Zielwoche (ziel = Montag der Zielwoche)
 * Einträge in der Zukunft sind vorgeschlagen, aber nicht angehakt; Einträge, die genau so schon am Zieltag stehen,
 * sind als Doppel markiert und nicht angehakt (ausser doppelOk: ein einzelner Eintrag darf bewusst doppelt gebucht werden).
 * @returns {{ quelle: object, datum: string, an: boolean, zukunft: boolean, doppelt: boolean }[]}
 */
export function kopierplan(eintraege, { modus, ziel, heute = isoDate(), bestehend = [], doppelOk = false }) {
  const schon = new Set(bestehend.map((l) => `${tagVon(l)}|${l.stunden}|${l.beschreibung ?? ''}|${l.refArtikel ?? ''}`));
  return [...eintraege]
    .sort((a, b) => tagVon(a).localeCompare(tagVon(b)))
    .map((quelle) => {
      const datum = modus === 'woche' ? addDays(ziel, (new Date(`${tagVon(quelle)}T12:00:00`).getDay() + 6) % 7) : ziel;
      const zukunft = datum > heute;
      const doppelt = schon.has(`${datum}|${quelle.stunden}|${quelle.beschreibung ?? ''}|${quelle.refArtikel ?? ''}`);
      return { quelle, datum, zukunft, doppelt, an: !zukunft && (doppelOk || !doppelt) };
    });
}

/** Dauer um Schritte verändern, in Viertelstunden, zwischen 0:15 und 24:00. */
export function dauerAendern(stunden, delta) {
  const neu = Math.round((Number(stunden) + delta) * 4) / 4;
  return Math.min(24, Math.max(0.25, neu));
}
